import { render, staticRenderFns } from "./MyMindAddGroupModal.vue?vue&type=template&id=56b20b5c&scoped=true"
import script from "./MyMindAddGroupModal.vue?vue&type=script&lang=js"
export * from "./MyMindAddGroupModal.vue?vue&type=script&lang=js"
import style0 from "./MyMindAddGroupModal.vue?vue&type=style&index=0&id=56b20b5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b20b5c",
  null
  
)

export default component.exports